
const PetaDigitalComponent = () => {

    const handleClick = () => {
        // Open URL in a new tab
        window.open('/peta_digital', '_blank');
        
        // Optionally, navigate internally as well
        // navigate('/some_internal_route');
    };
    return(
        <section id="peta_digital">
            <div className="container">
                <div className="row content">
                    <div className="col-md-4" data-aos="fade-right">
                        <img src={`${process.env.PUBLIC_URL}/template/img/details-2.png`} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-8 pt-5 order-2 order-md-1" data-aos="fade-up">
                        <h2 className="flex-content"><i className="bx bxs-map-alt mr-1"></i><b>Peta Digital</b></h2>
                        <br/>
                        <h3>Jelajahi data geospasial pada peta</h3>
                        <p className="font-size-medium font-weight-100">
                            Peta Digital menyajikan Data Geospasial di wilayah Kabupaten Sampang.
                        </p>
                        <br/><br/>
                        <a href='#' className="download-btn">
                            Buka Peta Digital
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PetaDigitalComponent;